import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { PhysicalInventoryModel } from 'src/app/models/inventory/physical-inventory.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PhysicalInventoryService {
  private readonly _httpClient = inject(HttpClient);

  adjustWithExcess(physicalInventoryId: number, storeId: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.put<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.AdjustWithExcess}/${physicalInventoryId}/${storeId}`, null);
  }

  adjustWithMissing(physicalInventoryId: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.put<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.AdjustWithMissing}/${physicalInventoryId}`,
      null);
  }

  createPhysicalInventory(physicalInventoryContract: PhysicalInventoryModel): Observable<PhysicalInventoryModel> {
    return this._httpClient.post<PhysicalInventoryModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.CreatePhysicalInventory}`,
      physicalInventoryContract
    );
  }

  deletePhysicalInventory(physicalInventoryId: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.delete<PhysicalInventoryModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.DeletePhysicalInventory}/${physicalInventoryId}`
    );
  }

  exportPhysicalInventoryReport(physicalInventoryId: number, selectedReport: number): Observable<Blob> {
    return this._httpClient.get(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventoryReport.ExportPhysicalInventoryReportAsync}/${physicalInventoryId}/${selectedReport}`, {
      responseType: 'blob',
    });
  }

  getAllPhysicalInventories(): Observable<PhysicalInventoryModel[]> {
    return this._httpClient.get<PhysicalInventoryModel[]>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetAllPhysicalInventories}`
    );
  }

  getAllStoresForSelectAsync(branchId: number, inventoryId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId).set('inventoryId', inventoryId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetAllStoresForSelectAsync}`,
      { params: params }
    );
  }

  getFirstPhysicalInventoryByKeysAsync(inventoryId: number, branchId: number, storeId: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.get<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetFirstPhysicalInventoryByKeys}/${inventoryId}/${branchId}/${storeId}`
    );
  }

  getLastPhysicalInventoryByKeysAsync(inventoryId: number, branchId: number, storeId: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.get<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetLastPhysicalInventoryByKeys}/${inventoryId}/${branchId}/${storeId}`
    );
  }

  getNextPhysicalInventoryByKeysAsync(inventoryId: number, branchId: number, storeId: number, consecutive: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.get<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetNextPhysicalInventoryByKeys}/${inventoryId}/${branchId}/${storeId}/${consecutive}`
    );
  }

  getPhysicalInventoryByKeysAsync(inventoryId: number, branchId: number, storeId: number, consecutive: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.get<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetPhysicalInventoryByKeys}/${inventoryId}/${branchId}/${storeId}/${consecutive}`);
  }

  getPreviusPhysicalInventoryByKeysAsync(inventoryId: number, branchId: number, storeId: number, consecutive: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.get<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetPreviusPhysicalInventoryByKeys}/${inventoryId}/${branchId}/${storeId}/${consecutive}`
    );
  }

  getPhysicalInventoryById(physicalInventoryId: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.get<PhysicalInventoryModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.GetPhysicalInventoryById}/${physicalInventoryId}`
    );
  }

  getPhysicalInventoryReport(physicalInventoryId: number, selectedReport: number): Observable<CustomTableReport> {
    return this._httpClient.get<CustomTableReport>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventoryReport.PhysicalInventoryReportAsync}/${physicalInventoryId}/${selectedReport}`
    );
  }

  setPhysicalInventoryState(physicalInventoryId: number): Observable<PhysicalInventoryModel> {
    return this._httpClient.put<PhysicalInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.SetPhysicalInventoryState}/${physicalInventoryId}`,
      null);
  }

  updatePhysicalInventory(physicalInventoryContract: PhysicalInventoryModel): Observable<PhysicalInventoryModel> {
    return this._httpClient.put<PhysicalInventoryModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.physicalInventory.UpdatePhysicalInventory}`,
      physicalInventoryContract
    );
  }
}
